<template>
  <div>
    <h3 class="modal-title"> FORM </h3>

    <b-form-group :class="{'error-input' : $v.data_form.title.$error}">
      <label> Form Title </label>
      <j-input
        v-model="$v.data_form.title.$model"
        :max-length="255"
        placeholder="Form Title"/>
    </b-form-group>
    <b-form-group :class="{'error-input' : $v.data_form.form.$error}">
      <label> Select Form </label>
      <j-single-select
        v-model="$v.data_form.form.$model"
        :load-options="loadOptionsForm"
        :is-async="true"
        :cache-option="false"
        :placeholder="'Select Form'"
        value-format="object"
        label="name"/>
        <!-- <p
        class="c--approved float-to-right cursor-pointer"
        style="margin-top: -21px"
        @click="addNewForm">
        Create Form
      </p> -->
    </b-form-group>
    <b-form-group :class="{'error-input' : $v.data_form.field.$error}">
      <label> Select Field </label>
      <j-multi-select
        v-model="$v.data_form.field.$model"
        :options="list_field"
        label="name"
        value-format="object"
        placeholder="Select Field"/>
    </b-form-group>
    <b-row>
      <b-col>
        <div class="float-to-right">
          <b-button
            class="btn gray m__r--5"
            @click="closeForm">
            Close
          </b-button>
          <b-button
            class="btn blue"
            @click="saveForm">
            Save
          </b-button>
        </div>
      </b-col>
    </b-row>

    <b-modal
      ref="modalCreateForm"
      class="mod-form"
      centered>
      <label>CREATE FORM</label>
      <b-form-group :class="{'error-input' : $v.data_create_form.name.$error}">
        <label> Form Name </label>
        <j-input
          v-model="$v.data_create_form.name.$model"
          :max-length="255"
          placeholder="Form Name"/>
      </b-form-group>
      <b-form-group :class="{'error-input' : $v.data_create_form.description.$error}">
        <label> Description </label>
        <j-textarea
          v-model="$v.data_create_form.description.$model"
          :max-length="300"
          placeholder="Description"/>
      </b-form-group>
      <div
        class="card-form-container">
        <j-form-master
          ref="jFormMasterData"
          :list-field="listField"/>
      </div>
      <br>
      <b-row>
        <b-col>
          <div class="float-to-right">
            <b-button
              class="btn gray m__r--5"
              @click="closeCreateForm">
              Close
            </b-button>
            <b-button
              class="btn blue"
              @click="createForm">
              Finish
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>

import { required } from 'vuelidate/lib/validators';
import { mapState, mapActions } from 'vuex';
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';

export default {
  props: {
    dataMaster: {
      type: Object,
      default: () => {},
    },
    modeCreate: {
      type: Boolean,
      default: false,
    },
    modeEdit: {
      type: Boolean,
      default: false,
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
  },
  validations: {
    data_form: {
      title: {
        required,
      },
      form: {
        required,
      },
      field: {},
    },
    data_create_form: {
      name: {
        required,
      },
      description: {

      },
    },
  },
  data() {
    return {
      data_form: {
        title: '',
        form: null,
        field: [],
      },
      data_create_form: {
        name: '',
        description: '',
      },
      listField: [],
      list_field: [],
      data_field: [],
    };
  },
  computed: {
    ...mapState('jStoreApplication', ['data_form_new', 'form_detail']),

    generateDataForm() {
      const dataField = {
        field: this.data_form.field.map(val => val.id),
        field_name: this.data_form.field.map(val => val.name),
      };

      const data = {
        value_id: `${this.data_form.form.id}`,
        pages_id: `${this.dataMaster.pages_id}`,
        name: this.data_form.title,
        component_master_id: this.dataMaster.id,
        info: JSON.stringify(dataField),
        type_platform: 1,
      };
      return data;
    },

    generateDataFormUpdate() {
      const dataField = {
        field: this.data_form.field.map(val => val.id),
        field_name: this.data_form.field.map(val => val.name),
      };

      const data = {
        value_id: `${this.data_form.form.id}`,
        pages_id: `${this.dataEdit.pages_id}`,
        name: this.data_form.title,
        order: this.dataEdit.order,
        component_master_id: this.dataMaster.id,
        info: JSON.stringify(dataField),
        type_platform: 1,
      };
      return data;
    },
  },
  watch: {
    data_form_new(data) {
      this.data_form.form = {
        id: data.id,
        name: data.name,
        label: data.name,
      };
    },

    // FOR EDIT
    form_detail(data) {
      if (this.dataMaster.name === 'form') {
        this.data_form.form = {
          id: data.id,
          name: data.name,
          label: data.name,
        };
      }
    },

    // eslint-disable-next-line
  'data_form.form': function(data) {
      const req = {
        additional_info_block: {
          id: Number(data.id),
        },
      };
      this.getDetailForms(req).then((res) => {
        const dataAdditional = res.additional_info.filter(filed => filed.is_delete === false);
        this.list_field = dataAdditional;
        this.data_form.field = [];

        if (this.data_field.length > 0) {
          dataAdditional.forEach((element) => {
            if (this.data_field.includes(element.id)) {
              this.data_form.field.push(element);
            }
          });
        }
      });
    },
  },
  mounted() {
    if (this.modeEdit) {
      this.getDetailForm({
        additional_info_block: {
          id: Number(this.dataEdit.value_id),
        },
      });

      this.data_form.title = this.dataEdit.name;
      const dataField = JSON.parse(this.dataEdit.info);
      this.data_field = dataField.field;
    }
  },
  methods: {
    ...mapActions('jStoreApplication', ['saveComponent', 'updateComponent', 'createNewForm', 'getDetailForm', 'getDetailForms']),

    saveForm() {
      this.$v.data_form.$touch();
      if (!this.$v.data_form.$error) {
        if (!this.modeEdit) {
          const dataParam = {
            data: this.generateDataForm,
            id: this.dataMaster.id,
          };
          this.saveComponent(dataParam);
        } else {
          const dataParam = {
            data: this.generateDataFormUpdate,
            id: this.dataMaster.id,
            component_id: this.dataEdit.id,
          };
          this.updateComponent(dataParam);
        }

        this.closeForm();
      }
    },

    closeForm() {
      this.$emit('close-field');
      this.data_form.title = '';
      this.data_form.form = null;
      this.data_form.field = [];
      setTimeout(() => {
        this.$v.data_form.$reset();
      }, 1000);
    },

    addNewForm() {
      this.$refs.modalCreateForm.show();
    },

    createForm() {
      this.$v.data_create_form.$touch();
      if (!this.$v.data_create_form.$error) {
        this.$refs.jFormMasterData.getData().then((data) => {
          const dataParam = {
            additional_info: data,
            description: this.data_create_form.description,
            id: 0,
            is_delete: false,
            name: this.data_create_form.name,
            smart_connect: {
              id: 0,
              is_use_amount: false,
              is_use_category: false,
              product_types: [],
            },
          };
          this.createNewForm(dataParam);

          this.closeCreateForm();
        });
      }
    },

    closeCreateForm() {
      this.$refs.modalCreateForm.hide();
      this.data_create_form.name = '';
      this.data_create_form.description = '';
      setTimeout(() => {
        this.$v.data_create_form.$reset();
      }, 1000);
    },

    loadOptionsForm({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH && searchQuery !== null) {
        if (searchQuery.length > 2) {
          const reqData = {
            pagination: {
              limit: 50,
              page: 1,
              column: '',
              ascending: true,
              query: searchQuery,
            },
          };
          this.$store.dispatch('jStoreApplication/getListForm', { reqData, callback });
        } else {
          callback(null, false);
        }
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pages/pages-component/jFormSetup.vue